import Keycloak from "keycloak-js"
import Config from "./config"

const keycloakConfig = new Keycloak(
    {
        url: Config.keycloakURL,
        // url: "https://robot.spartan-360.com",
        realm: Config.keycloakRealm,
        clientId: Config.keycloakClientId,
    }
);

export default keycloakConfig;